import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RED    = '#DC143C';
const GOLD   = '#D4AF37';
const DARK   = '#0a0404';
const BORDER = 'rgba(255,255,255,0.1)';
const MUTED  = 'rgba(255,255,255,0.35)';
const WHITE  = '#ffffff';

const TIER_INFO = {
  0: { label: "Visitante",           color: MUTED  },
  1: { label: "Logado G",            color: "#6660fe" },
  2: { label: "Tier 1 — Assinante",  color: GOLD   },
  3: { label: "Tier 3 — Full Magma", color: "#22c55e" },
};

export default function MinhaConta() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <AccountView /> : <AuthForms />;
}

function AuthForms() {
  const [mode, setMode] = useState("login");

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: DARK, padding: "40px 24px",
    }}>
      <div style={{ width: "100%", maxWidth: 440 }}>

        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 9, fontWeight: 700, color: RED,
            letterSpacing: "0.25em", textTransform: "uppercase", marginBottom: 14,
          }}>RR Magma</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 8 }}>
            <span style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 32, fontWeight: 800, color: WHITE, letterSpacing: "-0.04em" }}>RR</span>
            <div style={{ width: 1, height: 24, background: "rgba(220,20,60,0.4)" }} />
            <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 18, fontWeight: 800, letterSpacing: "0.2em", background: "linear-gradient(90deg,#FF4500,#FF6A00,#FFB300)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>MAGMA</span>
          </div>
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 10, color: MUTED, letterSpacing: "0.12em",
          }}>Inteligência Financeira</div>
        </div>

        {/* Toggle */}
        <div style={{
          display: "flex", marginBottom: 28,
          border: `1px solid ${BORDER}`, borderRadius: 6, overflow: "hidden",
        }}>
          {["login", "register"].map((m) => (
            <button key={m} onClick={() => setMode(m)} style={{
              flex: 1, padding: "10px",
              background: mode === m ? RED : "transparent",
              color: mode === m ? WHITE : MUTED,
              border: "none", cursor: "pointer",
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: 10, fontWeight: 700,
              letterSpacing: "0.12em", textTransform: "uppercase",
              transition: "all 0.15s ease",
            }}>
              {m === "login" ? "Entrar" : "Criar Conta"}
            </button>
          ))}
        </div>

        {mode === "login" ? <LoginForm /> : <RegisterForm />}

        <div style={{
          marginTop: 24, textAlign: "center",
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 11, color: MUTED,
        }}>
          Não tem assinatura?{" "}
          <Link to="/assinar" style={{ color: GOLD, textDecoration: "none", fontWeight: 700 }}>
            Ver planos →
          </Link>
        </div>
      </div>
    </div>
  );
}

function LoginForm() {
  const { login }  = useAuth();
  const navigate   = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [busy, setBusy]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await login(email, password);
      navigate("/mercado");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {error && <ErrorBox msg={error} />}
      <Field label="E-mail"  type="email"    value={email}    onChange={setEmail}    placeholder="seu@email.com" />
      <Field label="Senha"   type="password" value={password} onChange={setPassword} placeholder="••••••••"
        onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)} />
      <SubmitBtn busy={busy} disabled={!email || !password} onClick={handleSubmit}>
        {busy ? "Entrando..." : "Entrar"}
      </SubmitBtn>
      <div style={{ textAlign: "right", marginTop: -8 }}>
        <Link to="/esqueci-senha" style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 10, color: MUTED, textDecoration: "none", letterSpacing: "0.06em",
        }}>Esqueci minha senha →</Link>
      </div>
    </div>
  );
}

function RegisterForm() {
  const { register } = useAuth();
  const navigate     = useNavigate();
  const [name, setName]         = useState("");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [error, setError]       = useState("");
  const [busy, setBusy]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("As senhas não coincidem"); return; }
    if (password.length < 8)  { setError("Senha deve ter no mínimo 8 caracteres"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      navigate("/mercado");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {error && <ErrorBox msg={error} />}
      <Field label="Nome completo"   type="text"     value={name}     onChange={setName}     placeholder="Seu nome" />
      <Field label="E-mail"          type="email"    value={email}    onChange={setEmail}    placeholder="seu@email.com" />
      <Field label="Senha"           type="password" value={password} onChange={setPassword} placeholder="Mínimo 8 caracteres" />
      <Field label="Confirmar senha" type="password" value={confirm}  onChange={setConfirm}  placeholder="Repita a senha" />
      <SubmitBtn busy={busy} disabled={!name || !email || !password || !confirm} onClick={handleSubmit}>
        {busy ? "Criando conta..." : "Criar Conta"}
      </SubmitBtn>
    </div>
  );
}

function AccountView() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const tier = TIER_INFO[user.tier] ?? TIER_INFO[1];

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: DARK, padding: "40px 24px",
    }}>
      <div style={{ width: "100%", maxWidth: 480 }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 9, color: MUTED, letterSpacing: "0.2em",
            textTransform: "uppercase", marginBottom: 12,
          }}>Área do Assinante</div>
          <div style={{
            fontFamily: "'IBM Plex Serif', Georgia, serif",
            fontSize: 28, fontWeight: 900, color: WHITE,
          }}>
            Olá, <span style={{ color: RED }}>{user.name}</span>
          </div>
        </div>

        <div style={{ border: `1px solid ${BORDER}`, borderRadius: 8, overflow: "hidden", marginBottom: 20 }}>
          <div style={{
            background: "rgba(255,255,255,0.04)", padding: "14px 20px",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 10, color: MUTED, letterSpacing: "0.12em", textTransform: "uppercase",
            borderBottom: `1px solid ${BORDER}`,
          }}>Sua conta</div>
          <div style={{ padding: "20px", background: "rgba(255,255,255,0.02)" }}>
            <Row label="E-mail" value={user.email} />
            <Row label="ID"     value={`#${user.user_id}`} />
            <Row label="Plano"  value={
              <span style={{
                color: tier.color, fontWeight: 700,
                background: tier.color + "22",
                padding: "2px 8px", borderRadius: 3,
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 11,
              }}>{tier.label}</span>
            } />
          </div>
        </div>

        {user.tier < 3 && (
          <Link to="/assinar" style={{
            display: "block", width: "100%", padding: "13px",
            background: RED, color: WHITE,
            border: "none", borderRadius: 6,
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 11, fontWeight: 700, letterSpacing: "0.1em",
            textTransform: "uppercase", cursor: "pointer",
            textDecoration: "none", textAlign: "center",
            marginBottom: 12, boxSizing: "border-box",
          }}>Fazer upgrade →</Link>
        )}

        <button
          onClick={() => { logout(); navigate("/"); }}
          style={{
            width: "100%", padding: "13px",
            background: "transparent", color: MUTED,
            border: `1px solid ${BORDER}`, borderRadius: 6,
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 11, fontWeight: 700, letterSpacing: "0.1em",
            textTransform: "uppercase", cursor: "pointer",
          }}
        >Sair</button>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, placeholder, onKeyDown }) {
  return (
    <div>
      <label style={{
        display: "block", marginBottom: 6,
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 10, color: MUTED, letterSpacing: "0.12em", textTransform: "uppercase",
      }}>{label}</label>
      <input
        type={type} value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        style={{
          width: "100%", padding: "12px 14px", boxSizing: "border-box",
          border: `1px solid ${BORDER}`, borderRadius: 6,
          fontFamily: "'IBM Plex Mono', monospace", fontSize: 13,
          color: WHITE, background: "rgba(255,255,255,0.04)", outline: "none",
        }}
      />
    </div>
  );
}

function SubmitBtn({ busy, disabled, onClick, children }) {
  return (
    <button onClick={onClick} disabled={busy || disabled} style={{
      width: "100%", padding: "14px",
      background: busy || disabled ? "rgba(255,255,255,0.1)" : RED,
      color: WHITE, border: "none", borderRadius: 6,
      fontFamily: "'IBM Plex Mono', monospace",
      fontSize: 13, fontWeight: 800, letterSpacing: "0.08em",
      textTransform: "uppercase", cursor: busy || disabled ? "not-allowed" : "pointer",
    }}>{children}</button>
  );
}

function ErrorBox({ msg }) {
  return (
    <div style={{
      background: "rgba(220,20,60,0.1)", border: "1px solid rgba(220,20,60,0.3)",
      borderRadius: 6, padding: "12px 16px",
      fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: "#ff6b6b",
    }}>{msg}</div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "10px 0", borderBottom: `1px solid ${BORDER}`,
    }}>
      <span style={{
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: 10, color: MUTED, letterSpacing: "0.1em", textTransform: "uppercase",
      }}>{label}</span>
      <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: WHITE }}>
        {value}
      </span>
    </div>
  );
}